module.exports = __webpack_public_path__ + "img/bl-2a.24a0ee75.jpg";